<template>
  <div>
    <b-row>
      <b-col md="12" class="settings-panel">
        <div class="card">
          <div class="card-header text-center">
            Security Settings
          </div>
          <b-row>
            <b-col class="settings-panel-body securitysetting" v-if="form">
              <div class="card-block">
                <b-form class="mb-0">
                  <b-form-group id="exampleInputGroup1" label="Allow account access from these IP's only" label-for="ips">
                    <div class="label-desc">
                      You can either add a specific IP or a range of IP addresses ( e.g 203.0.113.* and 203.0.113.10 - 203.0.113.30 )
                    </div>
                      <div class="d-flex">
                        <b-form-input id="ips" type="text" v-model="newIpAddress" class="ip-address" required placeholder="xxx.xxx.xxx.xxx">
                        </b-form-input>
                        <b-btn class="ml-6" variant="outline-secondary" size="lg" @click="addIps">Add IP</b-btn>
                      </div>
                    <div class="form-input-note">Your current IP address is {{appInfo.IP}}</div>

                  </b-form-group>
                  <ul class="ml-14 list-ip-address">
                    <li v-for="(ip,index) in form.allowedLoginIPs" :key="index" class="chips">
                      {{ip}}
                      <a class="close-link" @click="removeIp(index)">
                        <close-icon class="icon-default closedark"></close-icon>
                      </a>
                    </li>
                  </ul>
                </b-form>
                <hr class="mb-0">
                <b-form>
                  <div>
                    <div  class="text-right settings-help"><b-link class="helper-links" :href="appInfo.SUPPORT_URL+'solution/articles/213799'+appInfo.GA_HELP_TRACKING" target="_blank">Help?</b-link></div>
                    <label class="mb-0">HTTP authentication / Folder protection</label>
                    <div class="label-desc">Enter your pre-configured Folder Protection credentials
                      <a class="helper-links" target="_blank" :href="appInfo.SUPPORT_URL+'solution/articles/213798'+appInfo.GA_HELP_TRACKING">Why is this needed?</a>
                    </div>
                    <div class="d-flex" style="width: 430px;">
                      <b-input v-model="form.httpAuth.username" class="w-50" id="user_input" placeholder="User name" />
                      <password-input  class="ml-2" idFor="inlineFormInputName3" v-model="form.httpAuth.password"></password-input>
                    </div>
                  </div>
                </b-form>
                <hr/>
                <div v-if="securityAuthType ==='authDuo'" class="text-right settings-help"><b-link class="helper-links" :href="duoSeeInstruction" target="_blank">Help?</b-link></div>
                <b-form>
                  <div>
                    <label class="mb-0">Two - Factor Authentication</label>
                    <span class="vue-switch-with-text">
                    <switches v-model="enabled"  theme="bootstrap"    color="primary" class="switch-alignment"></switches><span v-if="enabled" class="vue-switchbox-radio-button">Yes</span><span v-else class="vue-switchbox-radio-button">No</span></span>
                  </div>
                  
                  <b-form-group class="mt-10">
                       <b-form-radio-group class="custom-radio" radiobuttonDisable v-model="securityAuthType" :options="settingsOptions">
                        </b-form-radio-group> 
                  </b-form-group>
                  <div v-if="securityAuthType ==='authBasic'">
                    <div>
                      <p class="label-desc">A link and a 6-digit passcode will be sent to your email. You can either click on the link to login instantly or paste in the passcode to login.                     
                      </p>
                    </div>
                  </div>
                  <div v-if="securityAuthType ==='authDuo' && form.duoAuth"  >
                    <div>
                       <div class="label-desc mb-4">When you login with your email+password, a login request will be sent to your mobile phone. You can just tap to approve or deny the request. You can also authenticate it via a call or an SMS.                     
                      </div>
                      <div class="d-flex">
                        <div class="mr-2">
                          <label >Integration key</label>
                            <b-form-input  type="text" v-model="form.duoAuth.duo_ikey" required autocomplete="off">
                            </b-form-input>
                        </div>
                        <div class="mr-2">
                          <label >Secret key</label>
                            <b-form-input  type="text" v-model="form.duoAuth.duo_skey"   required autocomplete="off">
                            </b-form-input>
                        </div>
                        <div class="mr-2">
                          <label >API hostname</label>
                            <b-form-input  type="text" v-model="form.duoAuth.duo_api_host"  required autocomplete="off">
                            </b-form-input>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-form>
                   <hr>
                <b-form class="mt-1 mb-0">
                  <b-form-checkbox v-model="form.enableHTTPS" value="1" unchecked-value="0">Enable HTTPS
                  </b-form-checkbox>
                  <div class="label-desc pl-4">(Make sure this link -<a class="helper-links" :href="'https://'+appInfo.APP_DOMAIN_PATH" target="blank">https://{{appInfo.APP_DOMAIN_PATH}}</a> works before enabling HTTPS)</div>
                </b-form>
                <hr>
                <b-form class="mt-1 mb-0">
                  <b-form-checkbox v-model="form.enableSSLVerify" value="1" unchecked-value="0">Enable SSL Verification
                  </b-form-checkbox>
                </b-form>
              </div>
              <hr>
            </b-col>
          </b-row>
          <div class="card-footer text-muted text-right">
            <b-btn variant="primary" size="sm" @click="saveChanges" :disabled="buttonLoaders.saveChanges">Save Changes
              <spinner size="small" v-if="buttonLoaders.saveChanges"></spinner>
            </b-btn>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import PasswordInput from '../Common/PasswordInput';

import CloseIcon from '../../assets/close.svg';
import Vue from 'vue';
import Switches from "vue-switches";
export default {
  name: 'securitysettings',
  props: ['settings'],
  components: {
    PasswordInput,
    CloseIcon,
    Switches
  },
  created() {
    
    this.appInfo = this.$store.getters.getAppInfo;
    let installedAddons = this.$store.getters.getInstalledAddons;
    let checkInstalled = _.indexOf(installedAddons,'duoSecurity') > -1;
    if(checkInstalled){
      this.settingsOptions =  [
             { text: "Email Authentication", value: "authBasic",disabled: '' },
             { text: "Duo Security", value: "authDuo",disabled: '' }
           ]
    }else{
      this.settingsOptions =  [
             { text: "Email Authentication", value: "authBasic",disabled: '' },
           ]
    }

    let form = null;
    if (this.settings) {
      // console.log(this.settings);
      let settings = _.cloneDeep(this.settings);
      form = settings.securitySettings;
      if(form.loginAuthType ==='authNone' || form.loginAuthType == null || form.loginAuthType == ""){
        this.enabled = false;
        for(let i = 0; i<this.settingsOptions.length;i++){
          this.settingsOptions[i]['disabled'] = true;
        }
      }else{
        this.enabled = true;
        for(let i = 0; i<this.settingsOptions.length;i++){
          this.settingsOptions[i]['disabled'] = false;
        }
        this.securityAuthType = form.loginAuthType;
      }

    
      if (form && !form.httpAuth) {
        form.httpAuth = {
          username: '',
          password: ''
        };
      }
    }
    
    this.form = form;
  },
  data() {
    return {
      radiobuttonDisable:'',
      enabled: '',
      appInfo: {},
      form: {},
      appURL: window.appURL,
      buttonLoaders: {
        saveChanges: false
      },
      twoFactor: 'first',
      newIpAddress: '',
      securityAuthType: "",
      settingsOptions:[]
    };
  },
  computed:{
    duoSeeInstruction() {
      let supportURL = this.$store.getters.getAppInfo.SUPPORT_URL;
      let ga = this.$store.getters.getAppInfo.GA_HELP_TRACKING;
      return supportURL+'support/solutions/articles/212268-how-to-integrate-duo-security-to-your-admin-panel/'+ga;
    },
  },
  watch:{
    enabled:{
      handler: function(val, oldVal) {
        if(val == false){
          this. securityAuthType =  "";
          for(let i = 0; i<this.settingsOptions.length;i++){
          this.settingsOptions[i]['disabled'] = true;
        }
        }else{
          if(this.form.loginAuthType === 'authNone' || this.form.loginAuthType == null){
            this.securityAuthType = 'authBasic';
            for(let i = 0; i<this.settingsOptions.length;i++){
                this.settingsOptions[i]['disabled'] = false;
              }
          }else{
               this.securityAuthType =  this.form.loginAuthType;
              for(let i = 0; i<this.settingsOptions.length;i++){
                this.settingsOptions[i]['disabled'] = false;
              }
          }
         
        }
    }
    }
    
  },
  methods: {
    addIps() {
      this.form.allowedLoginIPs.push(this.newIpAddress);
      this.newIpAddress = '';
    },
   
    removeIp(index) {
      this.form.allowedLoginIPs.splice(index, 1);
    },
    saveChanges() {
      this.form.loginAuthType = this.securityAuthType === ''? 'authNone':this.securityAuthType;
      this.buttonLoaders.saveChanges = true;
      let payload = {};
      this.form.allowedLoginIPsCount = this.form.allowedLoginIPs.length;
      payload.requiredData = {
        updateSettingsAllV3: {
          securitySettings: this.form
        },
        getSettingsAllV3: 1
      };
      this.$store.dispatch('sendAction', payload).then(response => {
        this.buttonLoaders.saveChanges = false;
        this.$store.commit('SET_SETTINGS', response.data.getSettingsAllV3);
      });
    }
     
  }
};
</script>

<style scoped lang="scss">
  .vue-switchbox-radio-button{
  position: absolute;
  margin-left: 10px;
  font-size: 14px;
  font-family: lato;
  margin-top: 2px;

}
.custom-radio .custom-control-input:checked ~ .custom-control-label::after{
  color: #2386db !important;
}
.vue-switch-with-text{
    position: absolute;
    margin-left: 10px;
    margin-top: -1px;
}
.due-help{
  display: flex;
  justify-content: space-between;
}
.ip-address{
  width:  230px;
}
.list-ip-address{
  display: flex;
  flex-wrap: wrap;
  li{
    margin-right: 10px;
    margin-bottom: 10px;
  }
}
.switch-alignment{
  margin-bottom:0px;
}
</style>